import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'bg-primary flex flex-col items-center',
})`
  position: relative;
  background-color: ${(props) => props.bg};
  overflow: hidden;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ${(props) =>
    props.isIcsc &&
    `
    background-image: url('/icsc-background.jpeg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    .overlay {
      background: linear-gradient(rgba(48, 38, 168, 0.5), rgba(24, 38, 168, 0.5));
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 0;
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 1;
    }
  `}

  // box-shadow: 0px 9px 20px 3px rgba(0, 0, 0, 0.5);
  border-radius: 40px;
  padding-top: 60px;
  padding-bottom: 30px;
  padding-left: 40px;
  padding-right: 40px;

  .progress {
    width: 320px;
  }

  .title {
    margin-bottom: 20px;
    font-size: 30px;
    line-height: 23px;
    font-weight: 500;
  }
  .content-text {
    font-size: 15px;
    font-weight: 500;
  }

  @media only screen and (max-width: 639px) {
    padding-top: 40px;
    padding-left: 26px;
    padding-right: 26px;

    .title {
      font-size: 18px;
    }
    .content-text {
      font-size: 14px;
    }
  }
`;

export const ProgressBar = styled.div`
  width: 100px;
  height: 100px;
  margin-top: 30px;

  .CircularProgressbar-text {
    dominant-baseline: middle;
    text-anchor: middle;
  }
`;
